/** LOOM accent ramp — id → one mid-tone hex that reads on both light and dark themes (ID-22). */
export const LOOM_COLOR_HEX: Record<string, string> = {
  blue: '#2563eb',
  violet: '#7c3aed',
  green: '#16a34a',
  amber: '#d97706',
  rose: '#e11d48',
  cyan: '#0891b2',
  orange: '#ea580c',
  teal: '#0d9488',
  pink: '#db2777',
  lime: '#65a30d',
};
export const LOOM_COLOR_IDS = Object.keys(LOOM_COLOR_HEX);

/** Resolve a color id (or a raw hex) to a hex string. */
export function colorHex(color: string): string {
  return LOOM_COLOR_HEX[color] ?? color ?? '#2563eb';
}
